import { Component, OnInit } from '@angular/core';
import { GlobalLoaderComponent } from './components/global-loader/global-loader.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { HeaderNewComponent } from './pages/components/header/header-new.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        HeaderComponent,
        RouterOutlet,
        GlobalLoaderComponent,
        HeaderNewComponent,
        NgIf
    ],
})
export class AppComponent implements OnInit {
  title = 'cc-onboarding-fe';

  ngOnInit(): void {}

  isCustomerSearch(): boolean {
    const customerSearchRoutes = [
      'overview',
      'customer-search', 
      'change-address',
      'change-contact',
      'change-email',
      'change-name',
      'success',
      'document-upload',
      'change-phonenumber'
    ];
    
    return customerSearchRoutes.some(route => window.location.href.includes(route));
  }
}
